import { render, staticRenderFns } from "./BlogAuthorCreate.vue?vue&type=template&id=979c4da6&scoped=true&"
import script from "./BlogAuthorCreate.vue?vue&type=script&lang=js&"
export * from "./BlogAuthorCreate.vue?vue&type=script&lang=js&"
import style0 from "./BlogAuthorCreate.vue?vue&type=style&index=0&id=979c4da6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979c4da6",
  null
  
)

export default component.exports